<div class="tracking-page-simple-tracker-container" [formGroup]="formGroup">
  <pdq-card variant="popover" color="white" [formGroupName]="'widgets'">
    <div class="card" [formGroupName]="'simpleTracker'">
      <div class="header-container">
        <div class="header-title-section">
          <pdq-heading element="h5">Simple tracker</pdq-heading>
          <p class="header-description">Minimal tracking view</p>
        </div>
        <pdq-slide-toggle label="Simple tracker" labelSize="small" formControlName="showTrackingProgress">
        </pdq-slide-toggle>
      </div>

      @if (formGroup?.get('widgets')?.get('simpleTracker').get('showTrackingProgress')?.value) {
        <pdq-divider></pdq-divider>
        <div class="card__content">
          <div class="show-future-steps">
            <pdq-slide-toggle
              formControlName="showFutureSteps"
              label="Show future steps"
              subtext="Display upcoming steps in the delivery timeline"
              labelSize="small"></pdq-slide-toggle>
          </div>
          <div class="unsuccessful-tracking">
            <pdq-input-color
              label="Failed status color"
              [control]="formGroup?.get('widgets')?.get('simpleTracker').get('unsuccessfulTrackingStatusColor')"
              type="color"
              class="color-chooser"
              [formControl]="formGroup?.get('widgets')?.get('simpleTracker').get('unsuccessfulTrackingStatusColor')">
            </pdq-input-color>
            <pdq-button
              [style.color]="'var(--on-surface-light)'"
              [active]="unsuccessfulTrackingStatusColorPreviewButtonState"
              variant="secondary"
              size="medium"
              label="Preview"
              secondaryIcon="side_right_arrow"
              (onClick)="previewUnsuccessfulTrackingStatusColorClicked($event)">
            </pdq-button>
          </div>
        </div>
      }
    </div>
  </pdq-card>
</div>
